// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MYDV","option":"styles_option__1z6Fl","selected":"styles_selected__KObiM"};